<script setup>
import { onMounted, ref } from 'vue';
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Head, Link } from '@inertiajs/inertia-vue3';
    import BaseIcon from "@/Components/BaseIcon.vue";
    import { mdiEye, mdiTrashCan, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiBook, mdiSchool, mdiBookOpenVariant, mdiAndroidStudio,
        mdiDna } from "@mdi/js";

    defineProps({
        canRead: Boolean,
        canWrite: Boolean,
        canDelete: Boolean,
        courses: Array,
        level_label: String
        //select_coursearea: Array,
        //select_level: Array
    });

    onMounted(() => {
        listarTareas()
    });

    const countTareaWithResp = ref(0)
    const countTareaWithOutResp = ref(0)
    const arrayTareas = ref([])
    const arrayTareasPendientes = ref([])
    const arrayRespuestas = ref([])
    const listarTareas = () => {
        let url = '/task/dashboard';
        axios.get(url).then(function (response) {
            var respuesta = response.data;
            arrayTareas.value = respuesta.tareas;
            arrayRespuestas.value = respuesta.respuestas;
            arrayTareasPendientes.value = respuesta.tareasPendientes;
            countTareaWithOutResp.value = respuesta.countTareaWithOutResp;
            countTareaWithResp.value = respuesta.countTareaWithResp;
            console.log(arrayTareas.value);
            console.log(arrayRespuestas.value);
            console.log(countTareaWithOutResp.value);
            console.log(countTareaWithResp.value);
        }).catch(function (error) {
            console.log(error);
        });
    }


    const formatDate = (date) => {
        //var now = new Date().toLocaleDateString()
        var date = new Date(date)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result =  (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
        return result
    }

    const formatDateTime = (datetime) => {
        var date = new Date(datetime)// <-- Con let no funcionaba
        //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
        let result =  (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + '-' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
        return result
    }

    // LRR
    const data = {"estudiante_curso": [
                        {"id":1,"codigo": "2205-ARTE", "name":"ARTE", "tarea":"2/4 (FL 12/10/2022)", "anuncio":""},
                        {"id":2,"codigo": "2205-BIOLO", "name":"BIOLOGIA", "tarea":"2/4 (FL 12/10/2022)", "anuncio":"última fecha de entrega de trabajos este viernes ..."},
                        {"id":3,"codigo": "2205-FISICA", "name":"FISICA", "tarea":"2/2 (FL 12/10/2022)", "anuncio":"Entrega de trabajo grupal hasta el martes"},
                        {"id":4,"codigo": "2205-QUIMICA", "name":"QUIMICA", "tarea":"4/4 (FL 12/10/2022)", "anuncio":""},
                        {"id":5,"codigo": "2205-HISTO", "name":"HISTORIA DEL PERU", "tarea":"2/4 (FL 12/10/2022)", "anuncio":""},
                    ]};
</script>

<template>
    <Head title="Cursos" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Mis cursos | {{ level_label }}
            </h2>
        </template>
        <div class="pb-12">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-4">
                <div class="grid grid-cols-1 lg:grid-cols-6 gap-4">
                    <div
                        class="col-span-6 lg:col-span-4 bg-white rounded-lg shadow-lg py-10 px-6 bg-no-repeat md:bg-[url('/img/course/cursos.png')] bg-contain bg-right h-full">
                        <div class="flex items-center h-full">
                            <div class="grid grid-cols-4 gap-6">
                                <div class="col-span-4">
                                    <h5 class="text-gray-900 text-xl font-bold">Tablero de Cursos</h5>
                                    <p>
                                        Estrategias y herramientas para la supervisión y seguimiento de tu curso.
                                    </p>
                                </div>
                                <div class="col-span-4 md:col-span-2">
                                    <a href="#"
                                        class="flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow-md">
                                        <BaseIcon :path="mdiAndroidStudio " :size="40" class="mr-3 text-blue-600 w-10 h-10" />
                                        <span class="flex-1 ml-3 whitespace-nowrap">-</span><!-- Aritmetica -->
                                        <span
                                            class="inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-white bg-green-600 rounded ">Mejor Calificado</span>
                                    </a>
                                </div>
                                <div class="col-span-4 md:col-span-2">
                                    <a href="#"
                                        class="flex items-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow-md">
                                        <BaseIcon :path="mdiDna" :size="40" class="mr-3 text-green-600 w-10 h-10" />
                                        <span class="flex-1 ml-3 whitespace-nowrap">-</span><!-- Biologia -->
                                        <span
                                            class="inline-flex items-center justify-center px-2 py-0.5 ml-3 text-xs font-medium text-white bg-red-600 rounded d">Debes mejorar</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div
                        class="col-span-6 lg:col-span-2 p-6 bg-white border border-gray-200 rounded-lg shadow-md dark:bg-gray-800 dark:border-gray-700">
                        <BaseIcon :path="mdiSchool" :size="40" class="mr-3 text-rose-600 w-10 h-10" />
                        <a href="#">
                            <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">
                                Podemos apoyarte</h5>
                        </a>
                        <p class="mb-3 font-normal text-gray-500 dark:text-gray-400">Buscamos potenciar tu desarrollo,
                            hay un tutor que puede responder tus dudas:</p>
                        <Link href="#" class="btn btn-rose inline-flex items-center">
                            -<!-- Realiza tu consulta -->
                            <svg class="w-5 h-5 ml-2" fill="currentColor" viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z">
                                </path>
                                <path
                                    d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z">
                                </path>
                            </svg>
                        </Link>
                    </div>

                </div>
            </div>
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm rounded-lg">
                    <div class="p-6 bg-white border-gray-200">
                        <table>
                            <thead :set="respuestas = []">
                                <tr class="lg:block" :set="tareasPendientes = []">
                                    <th class="lg:w-20" />
                                    <th class="lg:w-60">Cursos</th>
                                    <th class="lg:w-60">Tareas</th>
                                    <th class="w-auto">Vencimientos</th>
                                </tr>
                            </thead>
                            <tbody :set="tareas = []">
                                <!-- data.estudiante_curso -->
                                <tr v-for="(curso, index) in courses" :key="curso.id"
                                    :set="tareas[index] = arrayTareas.filter(item => item.id_course == curso.id)"
                                    class="border mb-6 max-w-full block relative border-b-4 border-gray-100 lg:border-b dark:border-slate-800 rounded-lg">
                                    <td class="lg:w-20 before:hidden text-right lg:text-center mt-0-imp"  :id="'course'+curso.id">
                                        <Link :href="route('student-course-card', {'id': curso.id, 'back_link': 'course'+curso.id})">
                                            <div class="rounded-lg h-11 w-11 text-lg flex items-center justify-center text-white transition-colors duration-150 bg-red-500 focus:shadow-outline hover:bg-rose-700">
                                                
                                                    <BaseIcon :path="mdiBookOpenVariant" :size="28" />
                                                
                                            </div>
                                        </Link>
                                    </td>
                                    <td data-label="Curso" class="lg:w-60 mt-0-imp">
                                        <Link :href="route('student-course-card', {'id': curso.id, 'back_link': 'course'+curso.id})">
                                            <p class="font-semibold text-lg">
                                                    <!-- <span class="text-xs">{{ curso.ref }}</span>
                                                
                                                <br> -->
                                                    {{ curso.label }}
                                                                                            </p>
                                        </Link>
                                    </td>
                                    <td data-label="Tareas" class="lg:w-60 mt-0-imp" :set="respuestas[index] = arrayRespuestas.filter(item => item.id_course == curso.id)">
                                        <div v-if="tareas[index].length">
                                            <small class="text-gray-500 dark:text-slate-400" title="Tarea">
                                                {{ (respuestas[index].length ?? 0) }} entregados, quedan {{ (tareas[index].length ?? 0) - (respuestas[index].length ?? 0) }}<!-- {{ curso.tarea}} -->
                                            </small><br>
                                            <progress class="flex w-2/5 self-center lg:w-full" :max="(tareas[index].length ?? 0)" :value="(respuestas[index].length ?? 0)">
                                                
                                            </progress>
                                        </div>
                                        
                                    </td>
                                    <td data-label="Vencimientos" class="w-auto mt-0-imp" :set="tareasPendientes[index] = arrayTareasPendientes.filter(item => item.id_course == curso.id)">
                                        
                                        <small v-if="tareasPendientes[index].length" class="text-gray-500 dark:text-slate-400" title="Detalle">
                                            <div v-for="tp in tareasPendientes[index]" :key="tp.id">
                                                {{ formatDateTime(tp.end_date) }} - {{ tp.label }}
                                            </div>
                                        </small>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
